<template>

    <form ref="curso-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
					<div class="form-group col-md-12">
                        <label for="nome">Nome</label>
                        <input type="text" class="form-control" name="nome" placeholder="Nome" v-model="model.nome" required />
                    </div>
                    <div class="form-group col-md-12">
                        <label for="idiomaId">Idioma</label>
                        <select v-select="{ dataitem: 'Idioma', default: 'Selecione' }" v-model="model.idiomaId" class="form-control" name="idiomaId" required></select>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="ordem">Ordem</label>
                        <input type="text" class="form-control" name="ordem" placeholder="Ordem" v-model="model.ordem" required />
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="sistema" class="custom-control-input" v-model="model.sistema">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Sistema (interno)?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="ativo" class="custom-control-input" v-model="model.ativo">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Ativo?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="integraComCommerce" class="custom-control-input" v-model="model.integraComCommerce">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Integrar com commerce?</span>
                        </label>
                    </div>



        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "curso-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "curso-form-edit",
            
            resources: {
                edit: 'curso',
            },

        }),
		
        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false)return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ cursoId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>